module.exports = "<p>choose-mode works!</p>\r\n"